(function () {
  'use strict';

  angular
    .module('dashboard.lead.working')
    .controller('dashboardLeadWorkingCtrl', dashboardLeadWorkingCtrl);

  dashboardLeadWorkingCtrl.$inject = [
    'DashboardLeadWorking',
    '$translate',
    '$scope',
    '$timeout',
  ];

  function dashboardLeadWorkingCtrl(
    DashboardLeadWorking,
    $translate,
    $scope,
    $timeout,
  ) {
    var vm = this;

    var requestInProgress = false;
    vm.showChart = true;
    vm.noData = true;
    vm.lastUpdatedAt = new Date();
    vm.properties = [
      {
        name: 'tooltip-pattern',
        value: '{value} ' + $translate.instant('lead.popup.expires.days.full'),
      },
    ];
    vm.propLeadsStatuses = [
      {
        name: 'tooltip-pattern',
        value: '{value} ' + $translate.instant('lead.popup.expires.leads.full'),
      },
    ];

    var permittedColors = [
      '#5793F3',
      '#DD4444',
      '#FEC42C',
      '#D4DF5A',
      '#66bb6a',
      '#5578C2',
      '#ab47bc',
      '#FD9C35',
      '#3949ab',
      '#e91e63',
      '#00bcd4',
      '#DD4D79',
      '#ffeb3b',
      '#8d6e63',
      '#BD3B47',
    ];

    DashboardLeadWorking.getLeadNurturing().$promise.then(
      function (response) {
        requestInProgress = false;
        mapForChart(response);
      },
      function (error) {
        requestInProgress = false;
      },
    );

    function getAllStaff(arr) {
      return _(arr)
        .groupBy('status_name')
        .map(function (groupData) {
          var sumAvgDays = _.sumBy(groupData, function (i) {
            return parseInt(i.avg_days);
          });

          return Math.round(sumAvgDays / groupData.length);
        })
        .value();
    }

    function getEmployeeLeadsByStatus(arr) {
      return _(arr)
        .groupBy('status_name')
        .map(function (groupData) {
          return _.sumBy(groupData, function (i) {
            return parseInt(i.leads);
          });
        })
        .value();
    }

    function getDataByManagers(arr) {
      return _(arr)
        .groupBy('username')
        .map(function (groupData) {
          var statuses = getStatuses(arr);
          var uData = _(groupData)
            .groupBy('status_name')
            .map(function (userData) {
              return {
                statusName: userData[0].status_name,
                avgDays: userData[0].avg_days,
              };
            })
            .value();

          var result = [];
          statuses.forEach(function (st, i) {
            result[i] = '';
            uData.forEach(function (el) {
              if (el.statusName == st) {
                result[i] = el.avgDays;
              }
            });
          });

          result.unshift(groupData[0].username);

          return result;
        })
        .value();
    }

    function getLeadsByStatus(arr) {
      return _(arr)
        .groupBy('username')
        .map(function (groupData) {
          var statuses = getStatuses(arr);
          var uData = _(groupData)
            .groupBy('status_name')
            .map(function (userData) {
              return {
                statusName: userData[0].status_name,
                leads: userData[0].leads,
              };
            })
            .value();

          var result = [];
          statuses.forEach(function (st, i) {
            result[i] = '';
            uData.forEach(function (el) {
              if (el.statusName == st) {
                result[i] = el.leads;
              }
            });
          });

          result.unshift(groupData[0].username);

          return result;
        })
        .value();
    }

    function getStatuses(arr) {
      var statuses = _(arr)
        .groupBy('status_name')
        .map(function (groupData) {
          return groupData[0].status_name;
        })
        .value();

      return statuses;
    }

    function setDataForLeadNurturing(arr) {
      var allStaff, byManagers;

      allStaff = getAllStaff(arr);
      allStaff.unshift($translate.instant('reports.page.menu.employee.all'));
      $scope.data.push(allStaff);

      byManagers = getDataByManagers(arr);
      byManagers.forEach(function (el) {
        $scope.data.push(el);
      });
    }

    function setColorsAndStatuses(arr) {
      var statuses,
        colors = [];

      statuses = getStatuses(arr);
      statuses.forEach(function (el, i) {
        colors.push(permittedColors[i]);
      });
      colors.unshift('');
      statuses.unshift('');

      $scope.data.push(statuses);
      $scope.data.push(colors);

      $scope.employeeLeadsByStatus.push(statuses);
      $scope.employeeLeadsByStatus.push(colors);
    }

    function setDataForEmployeeLeadsByStatus(arr) {
      var employeeLeadsByStatus, leadsByStatus;

      employeeLeadsByStatus = getEmployeeLeadsByStatus(arr);
      employeeLeadsByStatus.unshift(
        $translate.instant('reports.page.menu.employee.all'),
      );
      $scope.employeeLeadsByStatus.push(employeeLeadsByStatus);

      leadsByStatus = getLeadsByStatus(arr);
      leadsByStatus.forEach(function (el) {
        $scope.employeeLeadsByStatus.push(el);
      });
    }

    function mapForChart(arr) {
      $scope.height = 545;
      $scope.width = 900;
      $scope.data = [];
      $scope.employeeLeadsByStatus = [];

      setColorsAndStatuses(arr);
      setDataForLeadNurturing(arr);
      setDataForEmployeeLeadsByStatus(arr);

      $timeout(function () {
        vm.noData = false;
      }, 1000);
    }
  }
})();
